import {FieldErrors, FieldValues, RegisterOptions, ValidationRule} from "react-hook-form";
import {DictionaryEntries} from "@web-libs/core/internationalization/dictionary.types";

const parseOptionToValue = (option: ValidationRule<any>): any => {
    if(option?.value){
        return option.value;
    } else {
        return option;
    }
}

export const mapErrorToMessage = <
    TFieldValues extends FieldValues = FieldValues,
    TFieldName extends string = string
>(dict: DictionaryEntries, error?:  FieldErrors<TFieldValues>[TFieldName], options?: RegisterOptions<any,any>, ): string|undefined => {
    const dictMapError = dict.validator.mapErrorMessages
    if (!error) {
        return
    }
    if (error.message && typeof error.message === "string") {
        return error.message;
    }
    if (error.type === "required") {
        return dictMapError.required;
    }
    if (error.type === "minLength") {
        return `${dictMapError.minLength} ${parseOptionToValue(options?.minLength)} ${dictMapError.beChar}`;
    }
    if (error.type === "maxLength") {
        return `${dictMapError.maxLength} ${parseOptionToValue(options?.maxLength)} ${dictMapError.beChar}`;
    }
    if(error.type === "min") {
        return `${dictMapError.min} ${parseOptionToValue(options?.min)} ${dictMapError.be}`;
    }
    if(error.type === "max") {
        return `${dictMapError.max} ${parseOptionToValue(options?.max)} ${dictMapError.be}`;
    }
    if (error.type === "pattern") {
        return dictMapError.pattern;
    }
    return dictMapError.invalid;
}
